/* Mobile product gallery: progress and count, swipe selects the colour, selected colour stays centred. */
(() => {
  document.querySelectorAll('[data-product-section]').forEach(section => {
    const slides = section.querySelector('[data-slides]');
    const jsonEl = section.querySelector('[data-product-json]');
    if (!slides || !jsonEl) return;
    const items = [...slides.querySelectorAll('.gallery__slide')];
    if (!items.length) return;
    const product = JSON.parse(jsonEl.textContent);

    /* photos from the 3rd onward load just before they are swiped to */
    const waiting = [...slides.querySelectorAll('img[data-src]')];
    const reveal = img => {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    };
    if (waiting.length) {
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(entries => entries.forEach(en => {
          if (en.isIntersecting) { reveal(en.target); io.unobserve(en.target); }
        }), { root: slides, rootMargin: '0px 100% 0px 100%' });
        waiting.forEach(i => io.observe(i));
      } else waiting.forEach(reveal);
    }

    items.forEach(s => {
      const img = s.querySelector('img');
      if (!img) return;
      const w = Number(img.getAttribute('width')), h = Number(img.getAttribute('height'));
      if (w && h && h / w > 1.1) s.classList.add('is-portrait');
    });

    let fill = null, num = null;
    if (items.length > 1) {
      const bar = document.createElement('div');
      bar.className = 'sdj-gbar';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span class="sdj-gbar__track"><span class="sdj-gbar__fill"></span></span><span class="sdj-gbar__n"></span>';
      slides.after(bar);
      fill = bar.querySelector('.sdj-gbar__fill');
      num = bar.querySelector('.sdj-gbar__n');
    }

    const current = () => {
      const base = items[0].offsetLeft;
      let best = 0, min = Infinity;
      items.forEach((s, i) => { const d = Math.abs(s.offsetLeft - base - slides.scrollLeft); if (d < min) { min = d; best = i; } });
      return best;
    };
    const paint = () => {
      if (!fill) return;
      const i = current();
      fill.style.width = ((i + 1) / items.length * 100) + '%';
      num.textContent = (i + 1) + ' / ' + items.length;
    };

    const group = section.querySelector('.swatches[data-option-index]');
    const centre = smooth => {
      if (!group || group.scrollWidth <= group.clientWidth) return;
      const b = group.querySelector('[aria-checked="true"]');
      if (!b) return;
      const g = group.getBoundingClientRect(), r = b.getBoundingClientRect();
      group.scrollTo({ left: group.scrollLeft + r.left - g.left - (g.width - r.width) / 2, behavior: smooth ? 'smooth' : 'auto' });
    };
    if (group) group.addEventListener('click', () => requestAnimationFrame(() => centre(true)));

    const byMedia = {};
    product.variants.forEach(v => { if (v.featured_media && !byMedia[v.featured_media.id]) byMedia[v.featured_media.id] = v; });
    const selectFromSlide = () => {
      if (!group) return;
      const v = byMedia[items[current()].dataset.mediaId];
      if (!v) return;
      const idx = Number(group.dataset.optionIndex), val = v.options[idx];
      const btn = [...group.querySelectorAll('[data-value]')].find(b => b.dataset.value === val);
      if (!btn || btn.getAttribute('aria-checked') === 'true') return;
      if (!product.variants.some(x => x.available && x.options[idx] === val)) return;
      btn.click();
    };

    let swiping = false, timer = 0, raf = 0;
    slides.addEventListener('touchstart', () => { swiping = true; }, { passive: true });
    slides.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(paint);
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (swiping) { swiping = false; selectFromSlide(); }
      }, 140);
    }, { passive: true });

    paint();
    centre(false);
  });
})();
